import MS from '../../../../commons/services/Moment'

export const TANK_LEVEL_KEY = [
  "s1SaltNaclLv",
  "b1BaseNaohLv",
  "a1AcidHclLv",
  "e1ElecNa2so4Lv",
  "s2SaltNaclLv",
  "b2BaseNaohLv",
  "a2AcidHclLv",
  "d1DrainLv"
];
export const TANK_LEVEL_NAME = [
  "S-1 Salt NaCl",
  "B-1 Base NaOH",
  "A-1 Acid HCl",
  "E-1 Electrolyte Na₂SO₄",
  "S-2 Salt NaCl",
  "B-2 Base NaOH",
  "A-2 Acid HCl",
  "Drain"
];

export const TANK_PH_KEY = [
  "s1SaltNaclPh",
  "b1BaseNaohPh",
  "a1AcidHclPh",
  "e1ElecNa2so4Ph",
  "s2SaphNaclPh",
  "b2BaseNaohPh",
  "a2AcidHclPh"
];
export const TANK_PH_NAME = [
  "S-1 Salt NaCl",
  "B-1 Base NaOH",
  "A-1 Acid HCl",
  "E-1 Electrolyte Na₂SO₄",
  "S-2 Salt NaCl",
  "B-2 Base NaOH",
  "A-2 Acid HCl"
];

export const TANK_CONDUCTIVITY_KEY = [
  "s1SaltNaclCond",
  "b1BaseNaohCond",
  "a1AcidHclCond",
  "e1ElecNa2so4Cond",
  "s2SaltNaclCond",
  "b2BaseNaohCond",
  "a2AcidHclCond"
];
export const TANK_CONDUCTIVITY_NAME = [
  "S-1 Salt NaCl",
  "B-1 Base NaOH",
  "A-1 Acid HCl",
  "E-1 Electrolyte Na₂SO₄",
  "S-2 Salt NaCl",
  "B-2 Base NaOH",
  "A-2 Acid HCl"
];

// ===== 변경: 충전 7개 + 방전 7개 = 14개 =====
export const FLOW_MODE_KEY = [
  // 충전
  "s11SaltNaclChargeFlow",
  "b11BaseNaohChargeFlow",
  "a11AcidHclChargeFlow",
  "e1ElecNa2so4ChargeFlow",
  "s21SaftNaclChargeFlow",
  "b21BaseNaohChargeFlow",
  "a21AcidHclChargeFlow",
  // 방전
  "s12SaltNaclDischargeFlow",
  "b12BaseNaohDischargeFlow",
  "a12AcidHclDischargeFlow",
  "e1ElecNa2so4DischargeFlow",
  "s22SaftNaclDischargeFlow",
  "b22BaseNaohDischargeFlow",
  "a22AcidHclDischargeFlow"
];
export const FLOW_MODE_NAME = [
  // 충전
  "S-1-1 Salt NaCl 충전",
  "B-1-1 Base NaOH 충전",
  "A-1-1 Acid HCl 충전",
  "E-1 Electrolyte Na₂SO₄ 충전",
  "S-2-1 Salt NaCl 충전",
  "B-2-1 Base NaOH 충전",
  "A-2-1 Acid HCl 충전",
  // 방전
  "S-1-2 Salt NaCl 방전",
  "B-1-2 Base NaOH 방전",
  "A-1-2 Acid HCl 방전",
  "E-1 Electrolyte Na₂SO₄ 방전",
  "S-2-2 Salt NaCl 방전",
  "B-2-2 Base NaOH 방전",
  "A-2-2 Acid HCl 방전"
];

// ===== 변경: 충전 7개 + 방전 7개 = 14개 =====
export const PRESSURE_MODE_KEY = [
  // 충전
  "s11SaltNaclChargePressure",
  "b11BaseNaohChargePressure",
  "a11AcidHclChargePressure",
  "e1ElecNa2so4ChargePressure",
  "s21SaptNaclChargePressure",
  "b21BaseNaohChargePressure",
  "a21AcidHclChargePressure",
  // 방전
  "s12SaltNaclDischargePressure",
  "b12BaseNaohDischargePressure",
  "a12AcidHclDischargePressure",
  "e1ElecNa2so4DischargePressure",
  "s22SaptNaclDischargePressure",
  "b22BaseNaohDischargePressure",
  "a22AcidHclDischargePressure"
];
export const PRESSURE_MODE_NAME = [
  // 충전
  "S-1-1 Salt NaCl 충전",
  "B-1-1 Base NaOH 충전",
  "A-1-1 Acid HCl 충전",
  "E-1 Electrolyte Na₂SO₄ 충전",
  "S-2-1 Salt NaCl 충전",
  "B-2-1 Base NaOH 충전",
  "A-2-1 Acid HCl 충전",
  // 방전
  "S-1-2 Salt NaCl 방전",
  "B-1-2 Base NaOH 방전",
  "A-1-2 Acid HCl 방전",
  "E-1 Electrolyte Na₂SO₄ 방전",
  "S-2-2 Salt NaCl 방전",
  "B-2-2 Base NaOH 방전",
  "A-2-2 Acid HCl 방전"
];

export const PANEL_ED_KEY = [
  "panelInputValtage",
  "panelInputAmprere",
  "panelPower",
  "panelWattage",
  "ed1ChargeVoltage",
  "ed1ChargeAmprere",
  "ed1ChargeWattage",
  "ed2DischargeVoltage",
  "ed2DischargeAmprere",
  "ed2DischargeWattage"
];
export const PANEL_ED_NAME = [
  "PANEL INPUT VOLTAGE",
  "PANEL INPUT AMPERE",
  "PANEL 순간전력",
  "PANEL 전력량",
  "ED1 충전모드 전압",
  "ED1 충전모드 전류",
  "ED1 충전모드 전력량",
  "ED2 방전모드 전압",
  "ED2 방전모드 전류",
  "ED2 방전모드 전력량"
];

export const TIME_KEY = [
  "time",
  "yyyy",
  "mm",
  "dd",
  "hh",
  "mi",
];


export const SEARCH_TIME_OPTION = [
  { "value": ["00:00:00", "03:00:00"], "text": "00:00:00 ~ 03:00:00" },
  { "value": ["01:00:00", "04:00:00"], "text": "01:00:00 ~ 04:00:00" },
  { "value": ["02:00:00", "05:00:00"], "text": "02:00:00 ~ 05:00:00" },
  { "value": ["03:00:00", "06:00:00"], "text": "03:00:00 ~ 06:00:00" },
  { "value": ["04:00:00", "07:00:00"], "text": "04:00:00 ~ 07:00:00" },
  { "value": ["05:00:00", "08:00:00"], "text": "05:00:00 ~ 08:00:00" },
  { "value": ["06:00:00", "09:00:00"], "text": "06:00:00 ~ 09:00:00" },
  { "value": ["07:00:00", "10:00:00"], "text": "07:00:00 ~ 10:00:00" },
  { "value": ["08:00:00", "11:00:00"], "text": "08:00:00 ~ 11:00:00" },
  { "value": ["09:00:00", "12:00:00"], "text": "09:00:00 ~ 12:00:00" },
  { "value": ["10:00:00", "13:00:00"], "text": "10:00:00 ~ 13:00:00" },
  { "value": ["11:00:00", "14:00:00"], "text": "11:00:00 ~ 14:00:00" },
  { "value": ["12:00:00", "15:00:00"], "text": "12:00:00 ~ 15:00:00" },
  { "value": ["13:00:00", "16:00:00"], "text": "13:00:00 ~ 16:00:00" },
  { "value": ["14:00:00", "17:00:00"], "text": "14:00:00 ~ 17:00:00" },
  { "value": ["15:00:00", "18:00:00"], "text": "15:00:00 ~ 18:00:00" },
  { "value": ["16:00:00", "19:00:00"], "text": "16:00:00 ~ 19:00:00" },
  { "value": ["17:00:00", "20:00:00"], "text": "17:00:00 ~ 20:00:00" },
  { "value": ["18:00:00", "21:00:00"], "text": "18:00:00 ~ 21:00:00" },
  { "value": ["19:00:00", "22:00:00"], "text": "19:00:00 ~ 22:00:00" },
  { "value": ["20:00:00", "23:00:00"], "text": "20:00:00 ~ 23:00:00" },
  { "value": ["21:00:00", "24:00:00"], "text": "21:00:00 ~ 24:00:00" }
]


// yyyy-MM-dd hh:mm:ss
export function setCategories({ fromDate, toDate }) {
  const categories = [];
  const startDate = new Date(fromDate);
  const endDate = new Date

  while (startDate <= endDate) {
    const yyyy = startDate.getFullYear();
    const mm = String(startDate.getMonth() + 1).padStart(2, "0");
    const dd = String(startDate.getDate()).padStart(2, "0");
    const hh = String(startDate.getHours()).padStart(2, "0");
    const mi = String(startDate.getMinutes()).padStart(2, "0");
    const ss = "00";

    categories.push(`${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`);

    startDate.setMinutes(startDate.getMinutes() + 1); // 1분 증가
  }

  return categories;
}

export function setOptionData(graphBaseData, objKey) {
  return graphBaseData.map(data => data[objKey]);
}

export function getChartOptions({
  chartId,
  categories,
  xAxisTitle,
  yAxisTitle,
}) {
  return {
    chart: {
      id: chartId,
      height: 350,
      type: 'line',
      animations: {
        enabled: true,
        easing: 'linear',
        animateGradually: {
            enabled: true,
            delay: 150
        },
      },
      toolbar: {
          show: true
      }
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
        curve: 'smooth'
    },
    grid: {
      show: true,
      borderColor: '#e7e7e7',
      row: {
          opacity: 0.5
      },
    },
    markers: {
      size: 0
    },
    xaxis: {
      tickAmount: 24,
      categories: categories,
      labels: {
        formatter: function (value) {
          return MS.format(value, 'HH:mm');
        },
        datetimeFormatter: {
            year: 'yyyy',
            month: 'MMM \'yy',
            day: 'dd MMM',
            hour: 'HH:mm'
        }
      }
    },
    yaxis: {
      title: {
        text: yAxisTitle,
      },
      labels: {
        formatter: function (value) {
          return value.toFixed(2);
        }
      },
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'right',
      floating: false,
      offsetY: 0,
      offsetX: 0
    }
  }
}
